import { useEffect, useState } from "react";

const useScreenMobile = ({
  size = 768,
  mobileFunc = () => {},
  desktopFunc = () => {}
}) => {
  const [isMobileView, setIsMobileView] = useState(false);

  const isProbablyMobileOrTablet = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isMobileUA = /Mobi|Android|iPhone|iPod/i.test(ua);
    const isIPadUA = /iPad/.test(ua);
    const isSpoofedIPad = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;

    return isMobileUA || isIPadUA || isSpoofedIPad;
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= size || isProbablyMobileOrTablet()) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    };

    handleResize(); // initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobileView) {
      mobileFunc();
    } else {
      desktopFunc();
    }
  }, [isMobileView]);

  return isMobileView;
};

export default useScreenMobile;